<template>
  <div>
    <h4 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
      {{ t('app.subscription.renewal.step2_title') }}
    </h4>

    <div class="space-y-4">
      <!-- Reference Number -->
      <div class="p-4 bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-400 rounded">
        <p class="text-sm font-semibold text-yellow-800 dark:text-yellow-300 mb-2">
          {{ t('app.subscription.renewal.important') }}
        </p>
        <p class="text-sm text-yellow-700 dark:text-yellow-400">
          {{ t('app.subscription.renewal.include_reference') }}
        </p>
      </div>

      <div class="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          {{ t('app.subscription.renewal.reference_number') }}
        </label>
        <div class="flex items-center gap-2">
          <input 
            :value="paymentData?.reference_number" 
            readonly
            class="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white font-mono text-lg"
          >
          <button 
            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            @click="$emit('copyReference')"
          >
            {{ t('app.subscription.renewal.copy_reference') }}
          </button>
        </div>
      </div>

      <!-- Bank Details -->
      <div class="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
        <h5 class="font-semibold text-gray-900 dark:text-white mb-3">
          {{ t('app.subscription.renewal.bank_details') }}
        </h5>
        <div class="space-y-2 text-sm">
          <div class="flex justify-between">
            <span class="text-gray-600 dark:text-gray-400">{{ t('app.subscription.renewal.bank') }}:</span>
            <span class="font-semibold text-gray-900 dark:text-white">{{ paymentData?.bank_details.bank }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600 dark:text-gray-400">{{ t('app.subscription.renewal.account') }}:</span>
            <span class="font-semibold text-gray-900 dark:text-white">{{ paymentData?.bank_details.account }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600 dark:text-gray-400">{{ t('app.subscription.renewal.clabe') }}:</span>
            <span class="font-semibold text-gray-900 dark:text-white">{{ paymentData?.bank_details.clabe }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600 dark:text-gray-400">{{ t('app.subscription.renewal.beneficiary') }}:</span>
            <span class="font-semibold text-gray-900 dark:text-white">{{ paymentData?.bank_details.beneficiary }}</span>
          </div>
        </div>
      </div>

      <!-- Amount -->
      <div class="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
        <div class="flex justify-between items-center">
          <span class="text-gray-700 dark:text-gray-300">{{ t('app.subscription.price') }}:</span>
          <span class="text-2xl font-bold text-blue-600 dark:text-blue-400">
            ${{ paymentData?.amount }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { RenewalResponse } from '@/services/paymentService'

interface Props {
  paymentData: RenewalResponse | null
}

defineProps<Props>()

defineEmits<{
  copyReference: []
}>()

const { t } = useI18n()
</script>
